import { t } from "@/i18n-js/instance";
import { isValueUnlimited } from "@circle-react/helpers/plansHelpers";
import { Typography } from "@circle-react-uikit/Typography";
import { CheckIcon } from "./CheckIcon";

interface NumberFeatureProps {
  suffix?: string;
  value: number;
}

export const NumberFeature = ({ value, suffix = "" }: NumberFeatureProps) => {
  const isEmptyValue = value === 0 || !value;
  return (
    <div className="flex items-center">
      {isEmptyValue ? (
        <Typography.BodyMd color="text-default">-</Typography.BodyMd>
      ) : (
        <>
          <CheckIcon />
          <Typography.BodyMd color="text-default">
            {isValueUnlimited(value)
              ? t("settings.billing.unlimited")
              : `${value}${suffix}`}
          </Typography.BodyMd>
        </>
      )}
    </div>
  );
};
